/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PeriodTypeName = {
    TwoWeeks: 'Two_Weeks',
    FourWeeks: 'Four_Weeks',
    OneMonth: 'One_Month'
} as const;

export type PeriodTypeName = typeof PeriodTypeName[keyof typeof PeriodTypeName];



